module.exports = __webpack_public_path__ + "img/arrow-left-s-line.390cfe6c.svg";